import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { fields } from '../../common/lib/redux-fields'
import { validateTestNameSignUp } from '../../common/auth/validations'
import { signUp, testSignUp } from '../../common/users/actions'
import formValidation from '../../common/lib/formValidation'
import { Button, TextInput, Checkbox, SocialAuth } from '../components'
import { roles } from '../../common/config'


class TestSignUpNameForm extends React.Component {
  componentWillUnmount() {
    const { fields } = this.props
    fields.$reset()
  }

  async submitForm(e) {
    const { fields, submit, registeringUser, testSignUp } = this.props
    e.preventDefault()
    const values = fields.$values()

    if (registeringUser) {
      const data = {
        ...values,
        ...registeringUser,
        setName: true,
        name: values.name && values.name.trim(),
        role: roles.USER,
      }
      if (await submit(data) !== false) {
        fields.$reset()
      }
    }
  }

  render() {
    const { fields, errorMessage, intl } = this.props

    return (
      <div>
        <TextInput
          {...fields.name}
          placeholder={intl.formatMessage(messages.enterName)}
        />
        <Checkbox
          id="privacyPolicyAgreement"
          checked={fields.privacyPolicyAgreement.value}
          onChange={() => {
            fields.privacyPolicyAgreement.onChange({ value: !fields.privacyPolicyAgreement.value })
          }}
          label={intl.formatMessage(messages.privacyPolicyAgreement)}
        />
        <p className="privacy-policy">
          {intl.formatMessage(messages.privacyPolicy)} <Link to="/privacy-policy">{intl.formatMessage(messages.here)}</Link>.
        </p>
        {errorMessage}
        <Button
          positive
          onClick={e => this.submitForm(e)}
        >
          {intl.formatMessage(messages.continue)}
        </Button>
      </div>
    )
  }
}

TestSignUpNameForm.defaultProps = {
  currentTest: null,
}

TestSignUpNameForm.propTypes = {
  intl: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  errorMessage: PropTypes.any.isRequired,
  currentTest: PropTypes.object,
  submit: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(state => ({
    registeringUser: state.users.registeringUser,
    currentTest: state.tests.currentTest,
  }), { signUp, testSignUp }),
  formValidation(props => ({
    validationFunc: validateTestNameSignUp,
    submitFunc: props.testSignUp,
  })),
  fields({
    path: 'TestSignUpNameForm',
    fields: [
      'name',
      'privacyPolicyAgreement',
    ],
    getInitialState: () => ({
      name: '',
      privacyPolicyAgreement: false,
    }),
  }),
  injectIntl,
)

export default enhance(TestSignUpNameForm)

const messages = defineMessages({
  enterName: {
    id: 'signUp.form.enterName',
    defaultMessage: 'Zadajte Vaše meno',
  },
  privacyPolicyAgreement: {
    id: 'signUp.form.privacyPolicyAgreement',
    defaultMessage: 'Súhlasím so spracovaním osobných údajov.',
  },
  privacyPolicy: {
    id: 'signUp.form.privacyPolicy',
    defaultMessage: 'Podmienky pre spracovanie osobných údajov nájdete',
  },
  here: {
    id: 'signUp.form.here',
    defaultMessage: 'tu',
  },
  continue: {
    id: 'signUp.form.continue',
    defaultMessage: 'Pokračovať',
  },
})



// WEBPACK FOOTER //
// ./src/browser/forms/TestSignUpNameForm.js